import { render, staticRenderFns } from "./UserAttendances.vue?vue&type=template&id=05c0ee16"
import script from "./UserAttendances.vue?vue&type=script&lang=js"
export * from "./UserAttendances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports